import { Routes } from '@angular/router';
import { orgaoRoutes } from '@/features/registro/orgaos/orgao.routes';
import { medicosRoutes } from '@/features/registro/medicos/medicos.routes';
import { prestadoresRoutes } from '@/features/registro/prestadores/prestadores.routes';
import { especialidadesRoutes } from '@/features/registro/especialidades/especialidades.routes';
import { prePrestadorRoutes } from '@/features/registro/pre-prestador/pre-prestador.routes';
import { preMedicoRoutes } from '@/features/registro/pre-medico/pre-medico.routes';

export const registroRoutes: Routes = [...medicosRoutes, ...prestadoresRoutes, ...orgaoRoutes, ...especialidadesRoutes, ...prePrestadorRoutes, ...preMedicoRoutes];

export default registroRoutes;
